import { render, staticRenderFns } from "./chose_spec.vue?vue&type=template&id=03918638&scoped=true"
import script from "./chose_spec.vue?vue&type=script&lang=js"
export * from "./chose_spec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03918638",
  null
  
)

export default component.exports